import { render, staticRenderFns } from "./baseProduct.vue?vue&type=template&id=04aced9e"
import script from "./baseProduct.vue?vue&type=script&lang=js"
export * from "./baseProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports